<template>
  <v-dialog
    v-model='visible'
    width="80%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
  >
    <v-stepper v-model='step'>
      <v-stepper-header>
        <div class='headline pa-5'>Kontakte importieren</div>
        <v-spacer></v-spacer>
        <v-stepper-step :complete='step > 1' step='1'></v-stepper-step>
        <v-icon>keyboard_arrow_right</v-icon>
        <v-stepper-step :complete='step > 2' step='2'></v-stepper-step>
        <v-icon>keyboard_arrow_right</v-icon>
        <v-stepper-step step='3'></v-stepper-step>
        <v-progress-linear
          v-if='$vars.loading'
          indeterminate
          class='primary--text loader'
        ></v-progress-linear>
      </v-stepper-header>
      <v-divider></v-divider>

      <v-stepper-items>
        <v-stepper-content step='1'>
          <v-card>
            <v-card-text style="min-height: 300px;">
              <v-file-input accept='.csv' prepend-icon="attach_file" label='CSV-Datei zum importieren auswählen' v-model='csvDatei'></v-file-input>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click='close'>Abbrechen</v-btn>
              <v-btn color='primary' @click='importInNeueBbr'>Weiter</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step='2'>
          <v-card>
            <v-card-text>
              Wähle die zu importierenden Spalten aus. Felder die keinen Wert zugewiesen bekommen werden nicht überschrieben.
              <v-simple-table fixed-header dense height="calc(100vh - 420px)">
                <thead>
                  <tr>
                    <th class='text-left'>Feld in Korpodesk</th>
                    <th class='text-left'>Spalte in CSV-Datei</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='item in kontaktfelder' :key='item.id'>
                    <td>{{ item.text }}</td>
                    <td><v-autocomplete v-if="kontaktfelder[item.id]" class="ma-0" clearable hide-details solo flat :items="bbrNeuFelder" v-model="kontaktfelder[item.id].importiert"></v-autocomplete></td>
                  </tr>
                </tbody>
              </v-simple-table> 
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click='step = 1'>Zurück</v-btn>
              <v-btn text @click='close'>Abbrechen</v-btn>
              <v-btn color='primary' @click='wechselHeader'>Weiter</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step='3'>
          <v-card>
            <v-card-title>
              Doppelte Kontakte
              <v-spacer></v-spacer>
              <v-btn outlined class="mb-2 mr-1" small @click="updateImportStatus('Neuer Kontakt')">Alle Importieren</v-btn>
              <v-btn outlined class="mb-2 mr-1" small @click="updateImportStatus('Original updaten')">Alle Updaten</v-btn>
              <v-btn outlined class="mb-2 mr-1" small @click="updateImportStatus('Nicht importieren')">Alle nicht Importieren</v-btn>
            </v-card-title>
            <v-card-text>
              Hier werden alle Kontakte angezeigt, die schon in Korpodesk gefunden wurden. Entscheide für jeden einzeln ob du einen neuen Kontakt erstellen, den vorhanden updaten oder den Kontakt überspringen willst.
              <v-simple-table fixed-header dense height="calc(100vh - 420px)">
                <thead>
                  <tr>
                    <th class='text-left'>Importierter Kontakt (CSV-Datei)</th>
                    <th>Vorhandener Kontakt (Klubdesk)</th>
                    <th>Kontakt auswählen</th>
                    <th>Übereinstimmung</th>
                    <th>ToDo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='item in bbrImportDoppelt' :key='item.id'>
                    <td>{{ item.importiert.nachname }}, {{ item.importiert.vorname }}</td>
                    <td>{{ item.original.nachname }}, {{ item.original.vorname }}</td>
                    <td><v-autocomplete hide-details class="ma-0" :items="bbrbbrKontaktImport" v-model="item.original"></v-autocomplete></td>
                    <th>{{ item.übereinstimmung }}</th>
                    <td><v-autocomplete hide-details class="ma-0" :items="übernahmeItems" v-model="item.übernehmen"></v-autocomplete></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click='step = 2'>Zurück</v-btn>
              <v-btn text @click='close'>Abbrechen</v-btn>
              <v-btn color='primary' @click="updateDoppelt">Weiter</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step='4'>
          <v-card>
            <v-card-text>
              <v-row class="ma-0 pa-0">
                <v-col cols="4" class="ma-0 pa-0">
                  <v-simple-table fixed-header dense height="calc(100vh - 420px)">
                    <thead>
                      <tr>
                        <th>Neue Kontakte ({{ bbrImport.length }})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for='item in bbrImport' :key='item.id'>
                        <td>{{ item.nachname }}, {{ item.vorname }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table> 
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-simple-table fixed-header dense height="calc(100vh - 420px)">
                    <thead>
                      <tr>
                        <th>Update Kontakte ({{ bbrUpdate.length }})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for='item in bbrUpdate' :key='item.id'>
                        <td>{{ item.item.nachname }}, {{ item.item.vorname }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table> 
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-simple-table fixed-header dense height="calc(100vh - 420px)">
                    <thead>
                      <tr>
                        <th>Nicht importierte Kontakte({{ bbrNichtImport.length }})</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for='item in bbrNichtImport' :key='item.id'>
                        <td>{{ item.item.nachname }}, {{ item.item.vorname }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table> 
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click='step = 3'>Zurück</v-btn>
              <v-btn text @click='close'>Abbrechen</v-btn>
              <v-btn color='primary' @click="saveNeueBbr" :loading="loading">In Kontakte Importieren</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
  import papa from 'papaparse'
  export default {
    props: ['visible'],
    data () {
      return {
        step: 1,
        csvDatei: [],
        kontaktfelder: [],
        bbrImport: [],
        bbrUpdate: [],
        bbrNichtImport: [],
        bbrImportDoppelt: [],
        bbrNeuFelder: [],
        übernahmeItems: ['Nicht importieren', 'Original updaten', 'Neuer Kontakt'],
        loading: false
      }
    },
    computed: {
      bbrbbr () { return this.$store.state.bbrbbr.bbrbbr }
    },
    methods: {
      importInNeueBbr () {
        const fileToLoad = this.csvDatei
        const reader = new FileReader()
        let bbrNeuFelder = []
        let bbrNeu = []
        let kontaktfelder = this.kontaktfelder
        reader.onload = fileLoadedEvent => {
          papa.parse(fileLoadedEvent.target.result, {
            header: false,
            encoding: 'ISO-8859-1',
            complete (results) {
              results.data[0].forEach(item => {
                bbrNeuFelder.push(item)
              })
              bbrNeuFelder.forEach(item => {
                kontaktfelder.forEach(feld => {
                  if (feld.system === item) {
                    feld.importiert = item
                  }
                  if (feld.text === item) {
                    feld.importiert = item
                  }
                })
              })
            },
            error (errors) {
              console.log('error', errors)
            }
          })
          papa.parse(fileLoadedEvent.target.result, {
            header: true,
            encoding: 'ISO-8859-1',
            complete (results) {
              results.data.forEach(item => {
                bbrNeu.push(item)
              })
            },
            error (errors) {
              console.log('error', errors)
            }
          })
        }
        reader.readAsText(fileToLoad)
        this.step = 2
        this.bbrNeuFelder = bbrNeuFelder
        this.bbrNeu = bbrNeu
      },
      wechselHeader () {
        // Ändern der Spaltenüberschriften
        let bbrImport = []
        this.bbrNeu.forEach(item => {
          let bbr = {}
          this.kontaktfelder.forEach(feld => {
            if (item[feld.importiert]) {
              bbr[feld.system] = item[feld.importiert]
            } else {
              bbr[feld.system] = ''
            }
          })
          bbrImport.push(bbr)
        })
        // Schauen nach doppelten Kontakten
        let bbrbbr = this.bbrbbr
        this.bbrImportDoppelt = []
        bbrImport.forEach(item => {
          bbrbbr.forEach(bbr => {
            if (this.similarity(item.nachname, bbr.nachname) > 0.85 && this.similarity(item.vorname, bbr.vorname) > 0.85) {
              this.bbrImportDoppelt.push({
                original: bbr,
                importiert: item,
                übereinstimmung: ((this.similarity(item.nachname, bbr.nachname) + this.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + '%',
                übernehmen: 'Nicht importieren'
              })
              console.log({
                original: bbr,
                importiert: item,
                übereinstimmung: ((this.similarity(item.nachname, bbr.nachname) + this.similarity(item.vorname, bbr.vorname)) / 2 * 100).toFixed(2) + '%',
                übernehmen: 'Nicht importieren'
              })
            }
          })
        })
        this.bbrImport = bbrImport
        this.step = 3
      },
      updateImportStatus (status) {
        this.bbrImportDoppelt.forEach(item => {
          item.übernehmen = status
        })
      },
      updateDoppelt () {
        this.bbrNichtImport = []
        this.bbrUpdate = []
        this.bbrImportDoppelt.forEach(item => {
          if (item.übernehmen === 'Nicht importieren') {
            this.bbrImport.splice(this.bbrImport.indexOf(item.importiert), 1)
            this.bbrNichtImport.push({
              item: item.importiert,
              id: item.original.id
            })
          } else if (item.übernehmen === 'Original updaten') {
            this.bbrImport.splice(this.bbrImport.indexOf(item.importiert), 1)
            this.bbrUpdate.push({
              item: item.importiert,
              id: item.original.id
            })
          }
        })
        this.step = 4
      },
      similarity (s1, s2) {
        var longer = s1
        var shorter = s2
        if (s1.length < s2.length) {
          longer = s2
          shorter = s1
        }
        var longerLength = longer.length
        if (longerLength === 0) {
          return 1.0
        }
        return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength)
      },
      editDistance (s1, s2) {
        s1 = s1.toLowerCase()
        s2 = s2.toLowerCase()

        var costs = []
        for (var i = 0; i <= s1.length; i++) {
          var lastValue = i
          for (var j = 0; j <= s2.length; j++) {
            if (i === 0) {
              costs[j] = j
            } else {
              if (j > 0) {
                var newValue = costs[j - 1]
                if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                  newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1
                }
                costs[j - 1] = lastValue
                lastValue = newValue
              }
            }
          }
          if (i > 0) {
            costs[s2.length] = lastValue
          }
        }
        return costs[s2.length]
      },
      saveNeueBbr () {
        this.loading = true
        this.bbrImport.forEach(item => {
          if (item.aktivenBeitrag) { item.aktivenBeitrag = parseFloat(item.aktivenBeitrag.replace(',', '.')).toFixed(2) }
          if (item.cvBeitrag) { item.cvBeitrag = parseFloat(item.cvBeitrag.replace(',', '.')).toFixed(2) }
          if (item.ahvBeitrag) { item.ahvBeitrag = parseFloat(item.ahvBeitrag.replace(',', '.')).toFixed(2) }
          if (item.hbvBeitrag) { item.hbvBeitrag = parseFloat(item.hbvBeitrag.replace(',', '.')).toFixed(2) }
          if (!item.kontoinhaber) { item.kontoinhaber = item.vorname + ' ' + item.nachname }
          if (item.receptionsdatum) {
            if (isNaN(item.receptionsdatum)) {
              let date = item.receptionsdatum
              let parts = date.split('.')
              item.receptionsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.geburtsdatum) {
            if (isNaN(item.geburtsdatum)) {
              let date = item.geburtsdatum
              let parts = date.split('.')
              item.geburtsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.philistrierungsdatum) {
            if (isNaN(item.philistrierungsdatum)) {
              let date = item.philistrierungsdatum
              let parts = date.split('.')
              item.philistrierungsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.mandatUnterschriftsdatum) {
            if (isNaN(item.mandatUnterschriftsdatum)) {
              let date = item.mandatUnterschriftsdatum
              let parts = date.split('.')
              item.mandatUnterschriftsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.letzterLastschrifteinzug) {
            if (isNaN(item.letzterLastschrifteinzug)) {
              let date = item.letzterLastschrifteinzug
              let parts = date.split('.')
              item.letzterLastschrifteinzug = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('kontakte').add(item)
            .then(key => {
              console.log('erstellt')
            })
            .catch((error) => {
              console.log(error)
            })
        })
        this.bbrUpdate.forEach(item => {
          if (item.item.aktivenBeitrag) { item.item.aktivenBeitrag = parseFloat(item.item.aktivenBeitrag.replace(',', '.')).toFixed(2) }
          if (item.item.cvBeitrag) { item.item.cvBeitrag = parseFloat(item.item.cvBeitrag.replace(',', '.')).toFixed(2) }
          if (item.item.ahvBeitrag) { item.item.ahvBeitrag = parseFloat(item.item.ahvBeitrag.replace(',', '.')).toFixed(2) }
          if (item.item.hbvBeitrag) { item.item.hbvBeitrag = parseFloat(item.item.hbvBeitrag.replace(',', '.')).toFixed(2) }
          if (!item.item.kontoinhaber) { item.item.kontoinhaber = item.item.vorname + ' ' + item.item.nachname }
          if (item.item.receptionsdatum) {
            if (item.item.receptionsdatum.indexOf('.') !== -1) {
              let date = item.item.receptionsdatum
              let parts = date.split('.')
              item.item.receptionsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.item.geburtsdatum) {
            if (isNaN(item.item.geburtsdatum)) {
              let date = item.item.geburtsdatum
              let parts = date.split('.')
              item.item.geburtsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          if (item.item.philistrierungsdatum) {
            if (isNaN(item.item.philistrierungsdatum)) {
              let date = item.item.philistrierungsdatum
              let parts = date.split('.')
              item.item.philistrierungsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          console.log(item)
          if (item.item.mandatUnterschriftsdatum) {
            console.log(item.item.mandatUnterschriftsdatum)
            if (isNaN(item.item.mandatUnterschriftsdatum)) {
              let date = item.item.mandatUnterschriftsdatum
              let parts = date.split('.')
              item.item.mandatUnterschriftsdatum = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
            console.log(item.item.mandatUnterschriftsdatum)
          }
          if (item.item.letzterLastschrifteinzug) {
            if (isNaN(item.item.letzterLastschrifteinzug)) {
              let date = item.item.letzterLastschrifteinzug
              let parts = date.split('.')
              item.item.letzterLastschrifteinzug = parts[2] + '-' + parts[1] + '-' + parts[0]
            }
          }
          const updateObj = {}
          Object.keys(item.item).forEach(key => {
            if ((item.item[key] !== undefined) && item.item[key] !== '') {
              updateObj[key] = item.item[key]
            }
          })
          updateObj.id = item.id
          this.$store.dispatch('bbrbbr/updateBbrData', updateObj)
          this.bbrNeu = []
          this.loading = false
          this.close()
        })
      },
      close () {
        this.step = 1
        this.bbrNeu = []
        this.kontaktfelder = []
        this.$emit('close', false)
      }
    },
    mounted () {
      this.$firebase.firestore().collection('vereine').doc(this.$vars.verbindung).collection('einstellungen').doc('kontaktfelder').get()
      .then(doc => {
        if (doc.exists) {
          let id = 0
          console.log(doc.data().neuFelder)
          doc.data().neuFelder.forEach(item => {
            this.kontaktfelder.push({
              id: id++,
              text: item.label,
              system: item.value,
              value: item.value,
              importiert: ''
            })
          })
        }
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// dialogImportKontakte.vue?e107605e